const GLITCH_COLOR_DEFAULT = '#48DE22';
const GLITCH_COLOR_LIGHT_THEME = '#48DE22';

export function initTextScramble() {
  const glitchElements = document.querySelectorAll('.text-scramble');
  if (!glitchElements.length) return;

  glitchElements.forEach((element) => {
    const targetText = getTargetText(element);
    if (!targetText) return;

    element.dataset.textScramble = targetText;
    element.setAttribute('data-text', targetText);

    const startGlitch = () => {
      element.style.setProperty('--text-scramble-accent', getGlitchColor(element));
      element.classList.add('is-glitching');
    };

    const stopGlitch = () => {
      element.classList.remove('is-glitching');
    };

    element.addEventListener('mouseenter', startGlitch);
    element.addEventListener('focus', startGlitch);
    element.addEventListener('mouseleave', stopGlitch);
    element.addEventListener('blur', stopGlitch);
  });
}

function getTargetText(element) {
  return element.dataset.textScramble ?? element.textContent.trim();
}

function getGlitchColor(element) {
  const navbar = element.closest('.navbar_container');
  if (navbar) {
    return navbar.classList.contains('is-on-light')
      ? GLITCH_COLOR_LIGHT_THEME
      : GLITCH_COLOR_DEFAULT;
  }

  const themedSection = element.closest('[theme]');
  const theme = themedSection?.getAttribute('theme')?.toLowerCase();
  return theme === 'light' || theme === 'white'
    ? GLITCH_COLOR_LIGHT_THEME
    : GLITCH_COLOR_DEFAULT;
}
